import * as React from "react";
import DemoButtons from "./Utiilities/DemoButtons";
import ImageSction1 from "../Assests/Images/Ed365/ImageSection1.png";
import Plans from "./Utiilities/Plans";
import Accordion from "./Utiilities/AccordionItem";
import SpecailButtons from "./Utiilities/SpecialButtons";
import Header from "./Header and Footer/Header";
import Footer from "./Header and Footer/Footer";
import ScrollToTop from "./Utiilities/ScrolltoTop";
import G2Badge from "./Utiilities/G2Badge";
import TabsWithImage from "./Utiilities/TabsWithImage";
import Availability from "./Utiilities/Availability";
import OurClients from "./Utiilities/OurClients";
import Integration from "./Utiilities/Integration";
import { MyContext } from "../App";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import GetOfferPage from "./Utiilities/GetOfferPage";
import CustomPlans from "./Utiilities/CustomPlans";
import Azuer from "./Utiilities/Azuer";
import OverviewCommon from "./GlobalMultiple/OverviewCommon";
import CyberSecurity from "./Utiilities/CyberSecurity";
import OverviewCommonET from "./GlobalMultiple/OverviewCommonET";
import LogoSlider from "./Utiilities/Slider";
import { RxCross1, RxHamburgerMenu } from "react-icons/rx";
import OverviewCommonLMS365 from "./GlobalMultiple/OverviewCommonLMS365";
import { Dropdown, PrimaryButton, TextField } from "@fluentui/react";
import OverviewCommonAsset365 from "./GlobalMultiple/OverviewCommonAsset365";
import OverviewCommonTS365 from "./GlobalMultiple/OverviewCommonTS365";
import Trustedbylogo from "./GlobalMultiple/Trustedbylogo";
import TimesheetClients from "./Utiilities/TimesheetClients";
// import { mouseflow} from "react-mouseflow";
const logos = [
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/soc_142hvt-qc.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/compliants_tM_PrC8N0Z.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/iso_D4yJ25IRn.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/microsoft_vdp9CYFMBj.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/Best%20ROI%201_96Mf_DosK.svg",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/medal%20(2)_JiluXJRGNl.svg",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/Best%20support%201_IGpX8xxqe3.svg",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/azure1_9hVzCGU2W.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/great-place_C3JVU5GXk.png",
];
function Timesheet365() {

    //GTM
    const script = document.createElement("script");
    script.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        
        gtag('consent', 'default', {
          'ad_storage': 'denied',
          'analytics_storage': 'denied',
          'functionality_storage': 'denied',
          'security_storage': 'granted',
          'wait_for_update': 500
        });
      `;
    document.head.appendChild(script);

    // React.useEffect(() => {
    //   mouseflow.initialize("d74e23c0-0490-4d54-925d-b4ea1ae7151a");
    //   }, []);
    const [ham, setHam] = React.useState(false);
    const AppName = React.useContext(MyContext);
    const [isLightboxOpen, setLightboxOpen] = React.useState(false);
    const [selectedImageUrl, setSelectedImageUrl] = React.useState("");
    const [isVideoPlaying, setIsVideoPlaying] = React.useState(false);
    const openLightbox = (imageUrl) => {
        setSelectedImageUrl(imageUrl);
        setLightboxOpen(true);
    };

    const closeLightbox = () => {
        setLightboxOpen(false);
    };
    const getEmbedUrl = (url) => {
        if (url.includes("youtube.com/watch?v=")) {
            return url.replace("watch?v=", "embed/");
        } else if (url.includes("youtu.be/")) {
            const videoId = url.split("youtu.be/")[1];
            return `https://www.youtube.com/embed/${videoId}`;
        } else if (url.includes("vimeo.com/")) {
            const videoId = url.split("vimeo.com/")[1];
            return `https://player.vimeo.com/video/${videoId}`;
        } else {
            return url; // fallback for direct video links
        }
    };
    const handlePlayClick = () => {
        setIsVideoPlaying(true); // When play icon is clicked, play the video
    };
    const handleCloseVideo = () => {
        setIsVideoPlaying(false); // Close the video
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    // React.useEffect(() => {
    //   document.title = "new title"
    // }, []);
    // React.useEffect(() => {
    //   mouseflow.initialize("d74e23c0-0490-4d54-925d-b4ea1ae7151a");
    //   }, []);
    React.useEffect(() => {
        document.title = "Timesheet 365 | AI-Powered Time Tracking Software for Teams";
        const metaDescription = document.querySelector("meta[name='description']");
        if (metaDescription) {
            metaDescription.setAttribute(
                "content",
                "Still tracking time in spreadsheets? Switch to Timesheet 365 for accurate employee productivity and time tracking."
            );
        } else {
            const newMeta = document.createElement("meta");
            newMeta.name = "description";
            newMeta.content = "Still tracking time in spreadsheets? Switch to Timesheet 365 for accurate employee productivity and time tracking.";
            document.head.appendChild(newMeta);
        }
    }, []);
    // const AppName = React.useContext(MyContext);

    // const [isLightboxOpen, setLightboxOpen] = React.useState(false);
    // const [selectedImageUrl, setSelectedImageUrl] = React.useState("");

    // const openLightbox = (imageUrl) => {
    //   setSelectedImageUrl(imageUrl);
    //   setLightboxOpen(true);
    // };

    // const closeLightbox = () => {
    //   setLightboxOpen(false);
    // };

    const accordionItems = [
        {
            title: "What Is AI Timesheet 365?",
            content: `AI Timesheet 365 is a Microsoft 365–based time tracking tool that helps teams log hours, manage tasks, and track projects directly inside Teams and SharePoint. `,
        },
        {
            title: `How does a SharePoint timesheet help manage employee hours?`,
            content: `A SharePoint timesheet lets teams log work hours, track tasks, and monitor project progress directly within SharePoint. It streamlines time tracking, simplifies approvals, and ensures accurate reporting for better workforce management. With automated reminders, real-time updates, and easy reporting, it helps managers keep teams accountable and projects on schedule.`,
        },
        {
            title: `Is Timesheet 365 easy to set up?`,
            content: `Yes. It installs directly into your Microsoft 365 environment and can be deployed quickly with minimal setup. `,
        },
        {
            title:
                "Can employees track time on mobile devices?",
            content: `Yes. Timesheet 365 includes a mobile-friendly interface, allowing your team to log hours or review tasks on the go. `,
        },
        {
            title: "Does Timesheet 365 generate detailed reports?",
            content: `Yes. It offers time tracking reports, billable hours of reporting, and integrations with Power BI for deeper insights.  `,
        },
        {
            title: "Can I use Timesheet 365 for project-based time tracking?",
            content: `Yes. You can track hours by task, project, client, or department, giving teams full visibility and accurate reporting.  `,
        },
        {
            title: "Can Timesheet 365 handle billing and invoicing?",
            content: `Yes. Timesheet 365 supports billable hours and can help generate accurate invoices based on tracked time. `,
        },
        {
            title: "What is SharePoint time tracking and why is it important for businesses?",
            content: `SharePoint time tracking lets teams log hours, tasks, and project activity directly within Microsoft SharePoint. With Timesheet 365, it eliminates manual errors, provides real-time visibility, and automates submissions and approvals for accurate reporting and efficient workforce management.`,
        },
        {
            title: "What benefits does SharePoint time tracking with Timesheet 365 offer compared to manual timesheets?",
            content: (
                <>
                    <span>With SharePoint time tracking powered by Timesheet 365, businesses get:</span>
                    <ul>
                        <li>Automated reminders and timesheet submissions</li>
                        <li>Accurate, real-time tracking of hours and tasks</li>
                        <li>Quick approvals with configurable workflows</li>
                        <li>Seamless integration into Microsoft Teams and Outlook</li>
                    </ul>
                </>
            ),
        },
        {
            title: `Which currency are the prices listed in?`, content: (
                "All prices are listed in USD."

            )
        },
    ];
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Timesheet 365 | AI-Powered Time Tracking Software for Teams</title>
                    <meta
                        name="description"
                        content="Still tracking time in spreadsheets? Switch to Timesheet 365 for accurate employee productivity and time tracking."
                    />
                </Helmet>
                <ScrollToTop />
                <div className={`HR_MainHeaderSection HR_panelHeader`} style={{ background: "#000" }}>
                    <div className="HR_FlexCenterSpcBetween ETHR_FlexCenterSpcBetween">
                        <div className="HR_LogoSection">
                            <img
                                src={"https://ik.imagekit.io/zn4au2jftpm5/Apps365/Logos/apps365white_yKjtDjv_y.png"}
                                alt="Apps 365"
                            />
                            {""}


                            <div className="DB_button">
                                <DemoButtons StickyButton={true} getStarted={true} openDialog={true} Dialogheading={"See how Timesheet 365 improves time tracking, reduces manual effort & centralizes employee work hours within MS 365"} DialogDescription={"Share your details and our team will walk you through the platform"} />
                            </div>
                            <div>
                                <span className="MBHAMBURGER" onClick={() => setHam(!ham)}>
                                    <RxHamburgerMenu />
                                </span>
                                {/* <span className="MBHAMBURGER" onClick={() => setHam(!ham)}> ≡</span> */}
                            </div>
                        </div>

                        <div className="HR_FlexCenterSpcBetween">
                            <div
                                className="HR_navMenu ETHR_navMenu LMSNavmenu "
                                style={{ paddingLeft: "0" }}
                            >
                                <span>
                                    <ul>

                                        <li>
                                            <div className="TS-logoIcons ">
                                                <img alt="MainImage" src="https://ik.imagekit.io/cubiclogics/App%20Logos/White-logos/TS365-White.png?updatedAt=1765794165731"
                                                ></img>
                                                <h3 className="HR_primaryclr" style={{ color: "#fff" }}>Timesheet 365</h3>
                                            </div>
                                        </li>
                                        <li>
                                            <a href="#Features">Features</a>
                                        </li>

                                        <li>
                                            <a href="#ClientsSpeakTestimonial">Testimonial</a>
                                        </li>
                                        <li>
                                            <a href="#Integration-ET">Integration</a>
                                        </li>
                                        <li>
                                            <a href="#pricing">Pricing</a>
                                        </li>
                                    </ul>
                                </span>
                            </div>

                            <div className="MB_button">
                                <DemoButtons StickyButton={false} getStarted={false} />
                            </div>

                            <div className="MB_button">
                                <DemoButtons StickyButton={true} getStarted={false} />
                            </div>
                        </div>
                    </div>
                </div>

                {ham ? (
                    <div
                        className="MBHB"
                        style={{
                            position: "fixed",
                            zIndex: "9",
                            top: "0vw",
                            paddingTop: "0.4vw 3vw",
                            background: "var(--panelBgColor)",
                            height: "100vh",
                        }}
                    >
                        <div className="mbflex">
                            <div className="HR_LogoSection">
                                <img
                                    src={"https://ik.imagekit.io/apps365/App-Logos/Apps365-black-logo-216x40px.png"}
                                    alt={AppName}
                                />
                                {/* <a href="https://www.apps365.com" target="_blank" rel="noreferrer">
                <img src={"https://ik.imagekit.io/apps365/App-Logos/Apps365-black-logo-216x40px.png"} alt="Apps365" />
                {""}
              </a> */}
                            </div>

                            {ham ? (
                                <div
                                    onClick={() => setHam(!ham)}
                                    style={{ margin: "12px 0px" }}
                                >
                                    <span className="cross">
                                        <RxCross1 />
                                    </span>
                                </div>
                            ) : (
                                <div onClick={() => setHam(!ham)}>
                                    <span className="cross">+</span>
                                </div>
                            )}
                        </div>
                        <div>
                            <span>
                                <ul className={`${ham ? "mbmenu" : ""}`}>
                                    <li>
                                        <div className="ET-logoIcons ET-logoIconsOnMobileView ">
                                            <img
                                                alt="MainImage"
                                                src="https://ik.imagekit.io/zn4au2jftpm5/hr365/LOGO/TS365_jAq8Ab_zO6.png?updatedAt=1706001833932"
                                            ></img>
                                            <h3 className="HR_primaryclr">Timesheet 365</h3>
                                        </div>
                                    </li>
                                    <li>
                                        <a href="#Features" onClick={() => setHam(false)}>
                                            Features
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#ClientsSpeakTestimonial"
                                            onClick={() => setHam(false)}
                                        >
                                            Clients
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#Integration-ET" onClick={() => setHam(false)}>
                                            Integration
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#pricing" onClick={() => setHam(false)}>
                                            Pricing
                                        </a>
                                    </li>
                                </ul>
                            </span>
                        </div>
                    </div>
                ) : (
                    ""
                )}

                {/* <Header HR365header="ET365" /> */}

                <div
                    style={{
                        backgroundColor: "unset",
                        background:
                            "linear-gradient(110deg, #daeaf6, #e8def8, #fdf0f0, #e8def8, #daeaf6)",
                    }}
                >
                    <div
                        className="HR_panel"
                        style={{
                            padding: "3vw 5vw 1vw 3vw",
                            background: "linear-gradient(45deg, #daeaf6, #e8def8, #fdf0f0, #e8def8, #daeaf6)",
                        }}
                    >
                        <div className="HR_FlexCenterSpcBetween HR_ParentSection1 ET365HomepageParentsection">
                            <div className="HR_Section1LeftSide LMS365-HR_Section1LeftSide">
                                <h1
                                    className="HR_primaryclr"
                                    style={{
                                        fontSize: "3vw !important",
                                        fontWeight: "800 !important",
                                        color: "#333 !important",
                                    }}
                                >
                                    Stop managing time across multiple tools. Improve Team Productivity with Time Tracking in Microsoft 365
                                </h1>
                                <span className="ET365-HerosectionSubheading"></span>
                                <p
                                    className="HR_textclr LMSHR_textclr" style={{ marginTop: "0.4vw" }}

                                >
                                    <p >
                                        {" "}
                                        Timesheet 365 is integrated with Microsoft Teams and SharePoint to help teams track hours, manage approvals, and generate reports in one place with real-time visibility.
                                    </p>
                                      <div className="herosectionPointsWrapper ">
                                        <div className="herosectionPoints">
                                            <p>✔ Track billable & non-billable hours</p>
                                        </div>

                                        <div className="herosectionPoints">
                                            <p>✔ Automate timesheet approvals</p>
                                        </div>

                                        <div className="herosectionPoints">
                                            <p>
                                               ✔ Generate real-time reports
                                            </p>
                                        </div>

                                        <div className="herosectionPoints">
                                            ✔ Track time inside Teams & SharePoint
                                        </div>

                                    </div>
                                    {/* <p >
                                        {" "}
                                        Timesheet 365 enables teams to log work hours across tasks and projects with structured approval workflows and centralized reporting. Built to operate within Microsoft 365, it eliminates the need for spreadsheets or separate tools.
                                    </p>
                                    <p>Designed for organizations that need accurate employee time data and clear visibility into team activity.</p> */}
                                </p>

                                <DemoButtons
                                    LMS365="LMS365"
                                    demobtnText="See Timesheet 365 in Action"
                                />
                            </div>
                            <div className="HR_Section1RightSide" style={{ width: "60%" }}>
                                <img
                                    className="HeroSectionImageStyles"
                                    style={{ width: "100%" }}
                                    alt="Timesheet 365"
                                    src="https://ik.imagekit.io/apps365/Lp-pages/Timesheet-feature%20%20image.png"
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                        <Trustedbylogo />
                        <div style={{ paddingTop: "1vw" }}></div>
                        <OverviewCommonTS365
                            MainHeading="Stop Managing Time Across Spreadsheets and Disconnected Tools"
                            MainDescription="Stop Managing Time Across Spreadsheets and Disconnected Tools"
                            MainImageAlt="ET365"
                        />
                        <div style={{ background: "linear-gradient(200deg, rgb(199 231 255 / 59%), rgb(226 208 255 / 64%), rgb(229 221 252 / 75%), rgb(217 206 236 / 67%), rgb(196 218 235 / 60%))" }}>
                            <h2
                                style={{ margin: "0px", paddingTop: "1.5vw", color: "#333" }}
                                className="HR_heading  ETHR_heading LMS_FeatureHeading"
                            >
                                Transform Time Tracking with Smart, Integrated Features
                            </h2>

                            <p className="AI-DescriptionStyles" style={{ margin: "0", marginBottom: "2vw", padding: "1vw 5vw" }}>
                                Timesheet 365 brings time entry, approvals, and reporting into a single workflow, so teams can log  hours, get approvals, and stay updated without switching tools.
                                <br />
                                This keeps time tracking organized, reduces manual errors and provides accurate data for reporting and operational visibility.


                            </p>
                            <div className="FeaturesWithImages" >
                                <div>
                                    <h2>Employee Time Tracking </h2>
                                    <p className="AI-DescriptionStyles">Track employee time across tasks, activities, and projects with clarity. Maintain detailed time logs that reflect actual work done across teams.
                                    </p>
                                </div>
                                <div style={{ width: "57%" }}>
                                    <img src="https://ik.imagekit.io/apps365/Lp-pages/Timesheet-banner-image.png" alt="" />
                                </div>
                            </div>

                            <div className="FeaturesWithImages FeaturesWithImages1" >
                                <div>
                                    <h2>Resource Allocation  </h2>
                                    <p className="AI-DescriptionStyles">Understand how work is distributed across your team and assign tasks in a way that prevents overload and keeps projects moving steadily.
                                    </p>
                                </div>
                                <div style={{ width: "47%" }}>
                                    <img src="https://ik.imagekit.io/apps365/Lp-pages/Timesheet-feature1.png?updatedAt=1774441135508" alt="" />
                                </div>
                            </div>
                            <div className="FeaturesWithImages" >
                                <div>
                                    <h2>Project Time Tracking</h2>
                                    <p className="AI-DescriptionStyles">Plan, track, and monitor time spent on projects and tasks to understand effort distribution. Gain better visibility into how time is allocated across workstreams.
                                    </p>
                                </div>
                                <div style={{ width: "57%" }}>
                                    <img src="https://ik.imagekit.io/apps365/Lp-pages/Project-time-tracking.png" alt="" />
                                </div>
                            </div>
                            <div className="FeaturesWithImages FeaturesWithImages1" >
                                <div>
                                    <h2>Billing & Invoice</h2>
                                    <p className="AI-DescriptionStyles">Convert recorded work hours into accurate billing data to support clear invoicing and ensure clients are billed correctly.
                                    </p>
                                </div>
                                <div style={{ width: "47%" }}>
                                    <img src="https://ik.imagekit.io/apps365/Lp-pages/billing-and-invoicing.avif" alt="" />
                                </div>
                            </div>
                            <div class="et-feature-container LMS365FeatureCards" style={{ paddingTop: "0" }}>

                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/apps365/Lp-pages/Smart%20AI-Powered%20Time%20Tracking%20Anywhere.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">AI-Powered Time Tracking Anywhere</h3>
                                    <p class="et-feature-desc">
                                        Track employee work hours and maintain accurate timesheets within Microsoft 365. Gain clear visibility and keep your team aligned with a single, reliable system.
                                    </p>
                                </div>
                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/apps365/Lp-pages/Built%20for%20Microsoft%20365-1.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Built for Microsoft 365</h3>
                                    <p class="et-feature-desc">
                                        Timesheet 365 integrates with Microsoft Teams, Outlook and SharePoint, enabling teams to log and track time within tools they already use.
                                    </p>
                                </div>
                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/apps365/Lp-pages/Approval%20Deadline.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Approval Deadlines</h3>
                                    <p class="et-feature-desc">
                                        Enable employees to submit timesheets effortlessly and managers to review and approve without delays supported by automated reminders and clear workflows.
                                    </p>
                                </div>
                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/apps365/Lp-pages/Task-Level%20Time%20Tracking.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Task-Level Time Tracking</h3>
                                    <p class="et-feature-desc">
                                        Track time at a granular level across tasks and activities for improved clarity and reporting accuracy.
                                    </p>
                                </div>

                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/apps365/Lp-pages/Time%20Reporting.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">
                                        Time Reporting
                                    </h3>
                                    <p class="et-feature-desc">
                                        Access detailed time reports to understand time usage across teams and projects and make informed decisions.
                                    </p>
                                </div>

                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/apps365/Lp-pages/Custom%20Fields.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Custom Fields</h3>
                                    <p class="et-feature-desc">
                                        Customize timesheets to match your workflow with flexible fields for projects, clients, job codes, locations & mor, capturing every detail accurately.
                                    </p>
                                </div>
                                {/* <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/cubiclogics/Logos/Role-Based%20Access%20Control.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Role-Based Access Control</h3>
                                    <p class="et-feature-desc">
                                        Control who can view, edit, or manage assets, keeping sensitive data secure while fostering collaboration across departments.
                                    </p>
                                </div> */}

                            </div>
                        </div>
                        <div
                            style={{
                                padding: "3vw",
                                background: "none",
                                paddingBottom: "2vw",
                            }}
                            className="overviewsection ETOverViewSection"
                        >
                            <h2 className="HR_heading" style={{ marginBottom: "0.5vw", color: "#333", margin: "0", paddingTop: "1.5vw" }}>
                                Why Choose Timesheet 365
                            </h2>

                            <p className="AI-DescriptionStyles" style={{ margin: "0" }}>
                                Timesheet 365 enables teams to track time, log hours, and update work from anywhere within Microsoft 365. By bringing time tracking into one centralized system, it gives you clear visibility into work hours, task ownership, and progress. You gain instant clarity on who is doing what and where time is going, helping your team stay aligned, accountable, consistently on track without delays and always one step ahead.
                            </p>

                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "1vw 0vw" }}>
                                <DemoButtons
                                    LMS365="LMS365"
                                    demobtnText="Start Tracking Work Hours with Timesheet 365"
                                />
                            </div>

                            <div
                                className="cybersection cybersectionET"
                                style={{ background: "none", paddingBottom: "1vw", paddingTop: "2vw" }}
                            >
                                <CyberSecurity PageName="ET365" />
                            </div>
                        </div>

                        <div></div>

                        <section className="sec">
                            <div>
                                <div
                                    className="easy"
                                    style={{ background: "none", padding: "0vw 5vw 3vw 5vw" }}
                                >
                                    <div className="Avilcard1 LMS_Avilcard1" >
                                        <div className="AvilcardStyle">
                                            <div className="stickerStyles">
                                                <div className="sticker">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/customer-support_wPk-OuZ23.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                            </div>
                                            <h3 className="custom" style={{ color: "#2323CE" }}>
                                                Customer Support
                                            </h3>
                                            <p className="easypera">
                                                Our support team merges technical prowess with sincere
                                                care, fostering trust through expertise and empathy.
                                                They build lasting relationships, transcending mere
                                                service to create meaningful connections.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="availcard2">
                                        <div className="cd1">
                                            <div
                                                className="c1"
                                                style={{
                                                    background: "#f9faffbb",
                                                }}
                                            >
                                                <div className="icon1">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/setting_z7IzKFspuo.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                                <div className="txt1">
                                                    <h3 className="Swift" style={{ color: "#2323CE" }}>
                                                        {" "}
                                                        AI Enabled Apps
                                                    </h3>
                                                    <p className="easypera">
                                                        Our innovative apps are built with the options of
                                                        Azure AI, Copilot, and custom AI solutions.
                                                    </p>
                                                </div>
                                            </div>

                                            <div
                                                className="c2"
                                                style={{
                                                    background: "#f9faffbb",
                                                }}
                                            >
                                                <div className="icon2">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/interface%20(1)_Bn8jFsKJE.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                                <div className="txt2">
                                                    <h3 className="Swift" style={{ color: "#2323CE" }}>
                                                        Modern UI/UX
                                                    </h3>
                                                    <p className="easypera">
                                                        Every app is crafted using the latest Fluent UI,
                                                        ensuring seamless functionality across all devices.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="cd2">
                                            <div
                                                className="c3"
                                                style={{
                                                    background: "#f9faffbb",
                                                }}
                                            >
                                                <div className="icon3">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/cloud-storage_wjvbbJkVt.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                                <div className="txt3">
                                                    <h3 className="Swift" style={{ color: "#2323CE" }}>
                                                        Swift Deployment
                                                    </h3>
                                                    <p className="easypera">
                                                        Choose any deployment
                                                        method—Teams,
                                                        Outlook, or SharePoint—that suits your preferences.
                                                    </p>
                                                    <span id="ClientsSpeakTestimonial" />
                                                </div>
                                            </div>
                                            <div
                                                className="c4"
                                                style={{
                                                    background: "#f9faffbb",
                                                }}
                                            >
                                                <div className="icon4">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/refresh__OBoe0tcU.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                                <div className="txt4">
                                                    <h3 className="Swift" style={{ color: "#2323CE" }}>
                                                        Free Updates{" "}
                                                    </h3>
                                                    <p className="easypera">
                                                        Our valued subscribers enjoy unlimited support,
                                                        enhancements, features, and updates.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>


                    <div id="client" className="IdChanges"></div>
                    <div
                        className="HR_whitesection"
                        style={{ background: "none", padding: "0vw 5vw 1vw 5vw" }}
                    >
                        <h2 className="HR_heading HR_MT" style={{ color: "#333", margin: "0" }}>Loved by teams. Trusted by leaders worldwide</h2>
                        <p class="et-integration-subtitle CustomerReviewStyles AI-DescriptionStyles">
                            Learn how organizations across the world track time accurately, ensure consistency and stay in control with Timesheet 365
                        </p>
                        <div className="HR_MT">
                            <TimesheetClients/>
                        </div>
                    </div>
                    <div class="et-integration-section LMS_integration-section" >
                        <div style={{ width: "100%" }}>
                            <h2 class="et-integration-title lMS_integration-title" >
                                Powerful Microsoft 365 Integrations,<br /> Zero Platform Switching
                            </h2>
                            <p class="et-integration-subtitle lMS_integration-subtitle" >
                                Timesheet 365 works directly within the Microsoft 365 ecosystem, allowing teams to log time, manage approvals, and review reports in one place—without the need for additional tools or separate systems.
                            </p>
                            <span id="pricing" />
                        </div>
                        <div style={{ width: "61%", margin: "0", padding: "0vw", }}>
                            <img src="https://ik.imagekit.io/cubiclogics/giff%20file/TS/Timesheet-integrations-gif.gif?updatedAt=1768829755976" alt="" />
                            {/* <video
                                src="https://ik.imagekit.io/apps365/Apps365/LMS/LMS%20(1).mp4"
                                autoPlay
                                muted
                                loop
                                playsInline
                                style={{ width: "85%", borderRadius: "0.5vw" }}

                            /> */}

                        </div>

                        {/* <div class="LMS-integration-grid">
              <div class="et-integration-card">
                <div class="et-icon-space">
                  <img
                    style={{ width: "100%" }}
                    alt="MainImage"
                    src="https://ik.imagekit.io/zn4au2jftpm5/CLM365/Power%20Automate%20(1)_eXEyQVXbrh.png?updatedAt=1735914125187"
                  />{" "}
                </div>
                <h3 class="et-card-title">Power Automate</h3>
                <p class="et-card-description">
                  Save time by automating ticket updates, notifications, and
                  approvals for smoother support management.
                </p>
              </div>

              <div class="et-integration-card">
                <div class="et-icon-space">
                  <img
                    style={{ width: "100%" }}
                    alt="MainImage"
                    src="https://ik.imagekit.io/zn4au2jftpm5/CLM365/Power%20Bi%20(1)_Kds_Hz7QcQ.png?updatedAt=1735914124948"
                  />
                </div>
                
                <h3 class="et-card-title">Power BI</h3>
                <p class="et-card-description">
                  Generate clear and detailed reports to better analyse support
                  performance and make informed decisions.
                </p>
              </div>

              <div class="et-integration-card">
                <div class="et-icon-space">
                  <img
                    style={{ width: "100%" }}
                    alt="MainImage"
                    src="https://ik.imagekit.io/zn4au2jftpm5/CLM365/power%20apps%20(1)_fKJEyRsAdu.png?updatedAt=1735914124951"
                  />
                </div>
                <h3 class="et-card-title">Power Apps</h3>
                <p class="et-card-description">
                  Use AI chatbots to instantly answer common customer support
                  queries or provide ticket updates.
                </p>
              </div>

              <div class="et-integration-card">
                <div class="et-icon-space">
                  <img
                    style={{ width: "100%" }}
                    alt="MainImage"
                    src="https://ik.imagekit.io/zn4au2jftpm5/CLM365/Power%20virtual%20Agent%20(1)_F7DLaFcFoe.png?updatedAt=1735914125177"
                  />
                </div>
                <h3 class="et-card-title">Power Virtual Agent</h3>
                <p class="et-card-description">
                  Build custom apps to enhance ticketing workflows and integrate
                  seamlessly with LMS 365.
                </p>
              </div>
            </div> */}

                    </div>

                    <div id="integration" className="IdChangesIntegration"></div>

                    <div className="IdChanges"></div>
                    <div className="HR_whitesection" style={{ background: "none" }}>
                        <h2 className="HR_heading HR_MT" style={{ color: "#333", marginBottom: "0vw" }}>
                            Timesheet 365 Pricing & Plans
                        </h2>
                        <p className="AI-DescriptionStyles" style={{ margin: "0", marginBottom: "1vw" }}>
                            Flexible pricing for growing teams and enterprises

                        </p>
                        <div className="HR_MT">
                            <div>
                                <Plans appName={"Timesheet 365"} />
                            </div>
                        </div>
                    </div>
                    <div className="AzureBoxStyles_LMS">
                        <div className="AzureBoxStyles_LMS_1">
                            <img style={{ width: "66%" }} src="https://ik.imagekit.io/zn4au2jftpm5/hr365/azure1_9hVzCGU2W.png" alt="" />
                            <h3 className="Azureheading" style={{ marginBottom: "0.8vw !important", paddingTop: "0.41vw" }}>Live on Azure</h3>
                            <p className="AzureText" style={{ textAlign: "center" }}>Buy directly from Azure Marketplace or via your enterprise agreement.</p>
                            <a className="Hr_Link" href="https://azuremarketplace.microsoft.com/en-us/marketplace/apps?search=hr365bizapps365&page=1">  Get started on Azure</a>
                        </div>
                        <div className="AzureBoxStyles_LMS_2" >

                            <img style={{ width: "65%" }} src="https://ik.imagekit.io/zn4au2jftpm5/Apps365/Random-Images/Untitled%20design%20(21)_nD6tRPn1n9.png" alt="" />
                            <h3 className="Azureheading">Special Pricing for NPOs</h3>

                            <SpecailButtons userCount={"50+"} LMS365="LMS365" hideSpecialrequest="hideSpecialrequest" SpecailButtonsText="Non-profits and government-funded educational institutes can avail exclusive rates." />
                        </div>
                        <div className="AzureBoxStyles_LMS_3">

                            <img style={{ width: "40%" }} src="https://ik.imagekit.io/apps365/Apps365/HD/Untitled%20design%20(27).webp" alt="" />
                            <h3 className="Azureheading" style={{ marginBottom: "0.8vw !important", paddingTop: "0.3vw" }}>Enterprise Pricing for 50+ Users
                            </h3>

                            <SpecailButtons userCount={"50+"} LMS365="LMS365" hideNPOrequest="hideNPOrequest" SpecailButtonsTextUser="Organizations with more than 50 users can avail special pricing." />
                        </div>


                    </div>
                    {/* <div
            className="Azuersection"
            style={{
              background: "none",
              paddingBottom: "0vw",
              paddingTop: "0vw",
            }}
          >
            <div className="AzureLogoText">
              <a
                href="https://azuremarketplace.microsoft.com/en-us/marketplace/apps?search=hr365bizapps365&page=1"
                target="_blank"
              >
                <img
                  className="AzureImage"
                  src="https://ik.imagekit.io/zn4au2jftpm5/hr365/azure1_9hVzCGU2W.png"
                  alt="Azure"
                />
              </a>
              <p className="AzureText">
                Using Azure? now you can{" "}
                <a
                  href="https://azuremarketplace.microsoft.com/en-us/marketplace/apps?search=hr365bizapps365&page=1"
                  target="_blank"
                >
                  buy
                </a>
                on Azure Marketplace or using your enterprise agreement
              </p>
            </div>
          </div> */}


                    <span className="privacytext"></span>
                    <div id="faq" className="IdChangesIntegration"></div>
                    <div class="et et-demo-section">
                        <h1 class="et et-demo-heading" style={{ margin: "0", padding: "0", color: "#333", paddingTop: "2vw" }}>
                            Manage Time Tracking Across Your Entire Organization
                        </h1>
                        <p class="et et-demo-subtext AI-DescriptionStyles" style={{ marginBottom: "0" }}>
                            Track employee hours within Microsoft 365. Ensure accurate timesheets and full visibility across your entire organization, improving productivity and accountability.
                        </p>

                        {/* <div class="et et-button-group">
              <DemoButtons
                hideDemoBtn="fasle"
                trailbtnText="Start Your 14-Day Free Trial button"
              />
            </div> */}
                        <form
                            id="lpgetstartedform"
                            className="lpgetstartedformclass "
                            style={{ padding: "2vw", background: "#f9faffbb", borderRadius: "0.5vw", paddingBottom: "0vw" }}
                        >
                            <div className="FooterContainer">
                                <div className="BottomFormleftimg">
                                    <img className="BottomFormImage" src="https://ik.imagekit.io/zn4au2jftpm5/Apps365/LMS365/LMS365-bottom-form_V3Jq3dsZk.png" alt="" />
                                </div>
                                <div className="FieldsButtonStyles">
                                    <div className="FormFieldStyles">
                                        <h3>Book a Personalized Timesheet 365 Demo!</h3>
                                        <DemoButtons LMS365demoForm={true} demobtnText="Book a Personalized Timesheet 365 Demo!" />
                                    </div>
                                    {/* <div className="ButtonandPrivacyText">
                    <PrimaryButton
                      style={{ background: "var(--btn-bg-color)", border: "none", fontSize: "1.1vw" }}
                      id="lpgetstartedsubmitbutton"
                      className="subButton"
                    // onClick={() => submitRequest("getstarted")}
                    >
                      {"Select a Time Slot"}

                    </PrimaryButton>

                  </div> */}
                                </div>
                            </div>
                        </form>
                        <div>
                            <h3 className="HR_faq">Frequently Asked Questions</h3>
                            <Accordion items={accordionItems} />
                        </div>
                    </div>
                </div>
                <Footer ET365={"ET365"} />
            </HelmetProvider>
        </>
    );
}
export default Timesheet365;
